import {useState,useEffect, useRef} from "react";
import {  useTranslation } from "react-i18next";
import SmartLink from '../../Components/SmartLink';
import UseLangLstQuery from "Apis/LangTxtInqApi";
import FooterApi from "Apis/FooterApi";
import MgpStore from "Stores/Store";
import GameCmntUi from "Views/Game/GameCmntUi";
import { GameCmntListType } from "Interface/GameCmnt.Interface";

// css
import  'Assets/css/GlbFtr.css';
import ApiError from "Utils/ApiError";
import GameRateUi from "Views/Game/GameRateUi";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

interface ChildComponentProps{
    gameSvcCd: string|undefined;
    gameMainPageData:any,
};

const GlbFtrUi = ( {gameSvcCd,gameMainPageData}:any) => {
    const location = useLocation();
    const footerRef = useRef<HTMLDivElement>(null);
    const gameRateAreaRef = useRef<HTMLDivElement>(null);
    const [gameSvcCdState,setGameSvcCdState] = useState(gameSvcCd);
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [gameMainPageInfoState,setGameMainPageInfoState] = useState<any>();
    const [gameCmntUiInfoState,setGameCmntUiInfoState] = useState<GameCmntListType>();
    const [isGameRateVisible, setIsGameRateVisible] = useState(false);
    const [hiddenHostChar, setHiddenHostChar] = useState('');
    const lastFooterHeightRef = useRef(0);
    const isPreReservationRoute = /^\/PreReservation_GrandOpen(\/|$)/i.test(location.pathname);
    const isTouchLikeDevice = () => {
        if (typeof window === "undefined" || !window.matchMedia) {
            return false;
        }
        return window.matchMedia("(hover: none), (pointer: coarse)").matches;
    };
    // useSelector로 실시간 로그인 상태 구독
    const loginInfoState = useSelector((state: any) => state.LoginInfoState?.LoginInfo?.apiBody);
    useEffect(()=>{
        FooterApi(gameSvcCd).then((resp)=> {
            switch(resp.apiHdr.code) {
                case "GAME0000":
                    setGameMainPageInfoState(resp.apiBody)
                    setGameCmntUiInfoState(resp.apiBody.cmntMenu)
                break;
                default:
                    ApiError(langData,resp.apiHdr.code)
                break;
            }

        });
            // setGameMainPageInfoState(resp.apiBody),
            // setGameCmntUiInfoState(resp.apiBody.cmntMenu)
    },[MgpStore.getState().LangSetState.Lang])

    // 현재 접속한 호스트(IP 포함) 마지막 문자만 숨김 요소로 보관
    useEffect(() => {
        const hostWithoutPort = (window.location.host || '').split(':')[0];
    }, []);

    useEffect(() => {
        const footerEl = footerRef.current;
        const rootContainer = footerEl?.closest('.rootContainer') as HTMLElement | null;
        let rafId: number | null = null;

        if (!footerEl || !rootContainer) {
            return;
        }

        const applyFooterHeight = () => {
            if (rafId != null) {
                window.cancelAnimationFrame(rafId);
            }

            rafId = window.requestAnimationFrame(() => {
                const rectHeight = Math.ceil(footerEl.getBoundingClientRect().height);
                const measuredHeight = Math.max(rectHeight, footerEl.offsetHeight, footerEl.scrollHeight);

                // Ignore transient zero-height frames during layout transitions.
                if (measuredHeight <= 0) {
                    const safeHeight = lastFooterHeightRef.current;
                    if (safeHeight > 0) {
                        rootContainer.style.setProperty('--ftr-height', `${safeHeight}px`);
                    }
                    return;
                }

                lastFooterHeightRef.current = measuredHeight;
                rootContainer.style.setProperty('--ftr-height', `${measuredHeight}px`);
            });
        };

        applyFooterHeight();
        window.addEventListener('resize', applyFooterHeight);

        let resizeObserver: ResizeObserver | undefined;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(() => applyFooterHeight());
            resizeObserver.observe(footerEl);
        }

        return () => {
            window.removeEventListener('resize', applyFooterHeight);
            if (rafId != null) {
                window.cancelAnimationFrame(rafId);
            }
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [gameMainPageInfoState, gameCmntUiInfoState, isGameRateVisible, langData]);

    useEffect(() => {
        const handleOutsidePress = (event: MouseEvent | TouchEvent) => {
            if (!isTouchLikeDevice() || !isGameRateVisible) {
                return;
            }

            const targetNode = event.target as Node;
            if (gameRateAreaRef.current && !gameRateAreaRef.current.contains(targetNode)) {
                setIsGameRateVisible(false);
            }
        };

        document.addEventListener("mousedown", handleOutsidePress);
        document.addEventListener("touchstart", handleOutsidePress, { passive: true });

        return () => {
            document.removeEventListener("mousedown", handleOutsidePress);
            document.removeEventListener("touchstart", handleOutsidePress);
        };
    }, [isGameRateVisible]);

    const handleGameRateClick = () => {
        if (isTouchLikeDevice()) {
            setIsGameRateVisible((prev) => !prev);
        }
    };

    const handleGameRateMouseEnter = () => {
        if (!isTouchLikeDevice()) {
            setIsGameRateVisible(true);
        }
    };

    const handleGameRateMouseLeave = () => {
        if (!isTouchLikeDevice()) {
            setIsGameRateVisible(false);
        }
    };

    const {t} = useTranslation();
    return(
        <div className='ftrWrap' ref={footerRef}>
            {gameCmntUiInfoState&&gameCmntUiInfoState.length > 0  && !isPreReservationRoute ?
                <GameCmntUi gameCmntUiInfoState={gameCmntUiInfoState}></GameCmntUi>    
            : <> </>}
            <div className="container1400">
                <ul  className='deviceIconWrap'>
                    <li>
                        <img src={process.env.PUBLIC_URL + "/images/Mainpage/WindowIcon.png"} alt="" />
                    </li>
                    <li>
                        <img src={process.env.PUBLIC_URL + "/images/Mainpage/MacIcon.png"} alt="" />
                    </li>
                </ul>
                <div className="trmsWrap">
                    <ul>
                        {gameMainPageInfoState&&gameMainPageInfoState.trmsMenu?
                        gameMainPageInfoState.trmsMenu.map((key:any)=>(
                            <li key={key.trmsUrl + key.trmsTitl}>
                                <SmartLink to={key.trmsUrl} onClick={() => window.scrollTo(0, 0)}>
                                    <p>{key.trmsTitl}</p>
                                </SmartLink>
                            </li>
                        )):<></>
                        }
                        
                        <li>
                            <SmartLink to="/Cs/Main" onClick={() => window.scrollTo(0, 0)}>
                                <p>{langData&&langData.GLB_HDR_CS_MAIN_BTN_00}</p>
                            </SmartLink>
                        </li>
                        {}
                        {gameMainPageInfoState&&gameMainPageInfoState.gameSvcCd ==="MGP"?
                            <></>:
                            <li className="gameRateLi" style={{cursor:"pointer"}}>
                                <div 
                                    ref={gameRateAreaRef}
                                    className="gameRateHoverArea"
                                    onClick={handleGameRateClick}
                                    onMouseEnter={handleGameRateMouseEnter}
                                    onMouseLeave={handleGameRateMouseLeave}
                                >
                                    {isGameRateVisible && (
                                        <div className="gameRateWrapper">
                                            <GameRateUi gameMainPageInfoState={gameMainPageInfoState}></GameRateUi>
                                        </div>
                                    )}
                                    <p>{langData&&langData.GLB_FTR_GAME_RTNG_MENU_00}</p>
                                </div>
                            </li>

                        }
                       {/* {MgpStore.getState().LangSetState.Lang ==="ko"?
                            <li>
                                <Link to="/PrntAthn?athnTypeCd=tmChse">
                                    <p>
                                        게임시간선택제
                                        {/* {langData&&langData.GLB_HDR_CS_MAIN_BTN_00}
                                    </p>
                                    {/* 고객센터
                                </Link>
                            </li>:<></>

                        }*/}
                    </ul>
                </div>
                <div className="csAddr">
                    <ul>
                        <li>
                            <p>{gameMainPageInfoState&&gameMainPageInfoState.csCmpnyNm}</p>
                        </li>
                        <li>
                            <p>{gameMainPageInfoState&&gameMainPageInfoState.csAddr}</p>
                        </li>
                         {/* <li>
                            <p>{langData&&langData.GLB_FTR_INFO_NO_LBL_02} </p>
                        </li> */}
                        <li>
                            <p>{langData&&langData.GLB_FTR_TEL_NO_LBL_00} {gameMainPageInfoState&&gameMainPageInfoState.csTelNo}</p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            {/* <p>{langData&&langData.GLB_FTR_INFO_NO_LBL_04}  {gameMainPageInfoState&&gameMainPageInfoState.csEml}</p> */}
                            <p>{gameMainPageInfoState&&gameMainPageInfoState.csEml}</p>
                        </li>
                        <li>
                            <p>{langData&&langData.GLB_FTR_INFO_NO_LBL_00} 314-81-48576</p>
                        </li>
                        
                        <li>
                            <p>{langData&&langData.GLB_FTR_INFO_NO_LBL_01} 2018-서울마포-2112</p>
                        </li>
                    </ul> 
                </div>
                
                <div className="cpyr">

                    <p dangerouslySetInnerHTML={{__html: gameMainPageInfoState && gameMainPageInfoState.cpyr ? gameMainPageInfoState.cpyr : ''}} />
                    <span style={{color: "#000e14" ,position:"absolute"}} aria-hidden="true">{loginInfoState?.srvrNo}</span>
                </div>
                
            </div>
        </div>
    )
}

export default GlbFtrUi;